module.exports = __webpack_public_path__ + "img/tj.a0080f89.svg";